import { requestTool } from "../tools";

const getTree = () => requestTool.getRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetActiveTreeNodeSummaries");

export const layerService = {
    getTree
};

export default layerService;
